import * as React from 'react';
import Button from '../../../../components/Button';
import { HomeTabListFooterStyle } from './style';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';

interface HomeTabListFooterProps {
  onSave: () => void;
  onReset: () => void;
  onPreview: () => void;
  canShowSaveAndReset: boolean;
}

const HomeTabListFooter = (props: HomeTabListFooterProps): JSX.Element => {
  const { onSave, onReset, onPreview, canShowSaveAndReset } = props;

  return (
    <FixedBottomNavBar>
      <HomeTabListFooterStyle>
        <div className="left">
          <Button text={'미리보기'} onClick={onPreview} />
        </div>
        {canShowSaveAndReset && (
          <div className="right">
            <Button text={'초기화'} onClick={onReset} />
            <Button text={'저장'} color="primary" onClick={onSave} />
          </div>
        )}
      </HomeTabListFooterStyle>
    </FixedBottomNavBar>
  );
};

export default HomeTabListFooter;
